import { render, staticRenderFns } from "./AppQuestion8.vue?vue&type=template&id=6fecb758&"
import script from "./AppQuestion8.vue?vue&type=script&lang=js&"
export * from "./AppQuestion8.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports